import React, { useState } from 'react';
import { Input, Select, Button } from '../components/ui';

export default function ServiceForm({ service, onSubmit, onCancel }) {
  const [form, setForm] = useState({
    name: service?.name || '',
    type: service?.type || '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  const serviceTypes = [
    { value: 'consulting', label: 'Consulting' },
    { value: 'development', label: 'Development' },
    { value: 'maintenance', label: 'Maintenance' },
    { value: 'support', label: 'Support' }
  ];

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Name"
        value={form.name}
        onChange={e => setForm({ ...form, name: e.target.value })}
        required
      />

      {/* <Select
        label="Type"
        value={form.type}
        options={serviceTypes}
        onChange={e => setForm({ ...form, type: e.target.value })}
        required
      /> */}

      <div style={{ marginTop: 20 }}>
        <Button type="submit" style={{ marginRight: 10 }}>
          {service ? 'Update' : 'Create'} Service
        </Button>
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
}